const showCommentBox = (controller, target) => {
  let itemId = target.dataset.itemId;
  if (itemId && target.classList.contains('item-type-comment')) {
    controller.stimulate('Comment#show_item_comments', itemId);
  }
};

export default showCommentBox;
